import { AdminLoginForm } from "../components/AdminLoginForm";

export function AdminLoginRoute() {
  return (
    <main className="landing">
      <AdminLoginForm />
    </main>
  );
}
